class Hero extends HTMLElement {

  constructor() {
    super()

    this.props = {
      baseClass: 'js-hero'
    }

    this.els = {
      iframe: this.querySelector(`.${this.props.baseClass}-iframe`),
      scrollDownButton: this.querySelector(`.${this.props.baseClass}-scroll-down`),
    }
  }

  hasAccessToIframe() {
    const key = `${(+new Date)}_${Math.random()}`

    try {
      const iframe = this.els.iframe.contentWindow
      iframe[key] = 'asd'

      return iframe[key] === 'asd'
    } catch {
      return false
    }
  }

  scrollDown() {
    this.nextElementSibling.scrollIntoView()
  }

  setIframeHeight() {
    if (!this.hasAccessToIframe()) return

    const iframeDOM = this.els.iframe.contentWindow.document
    const iframeHeight = iframeDOM.body.offsetHeight
    const heightIsInteger = iframeHeight === parseInt(iframeHeight, 10)

    if (heightIsInteger) {
      this.els.iframe.style.height = `${iframeHeight}px`
    }
  }

  bindEvents() {
    this.els.iframe?.addEventListener('load', (e) => this.setIframeHeight(e))
    this.els.scrollDownButton?.addEventListener('click', (e) => this.scrollDown(e))
  }
  
  connectedCallback() {
    this.bindEvents()
  }

}

customElements.define('m-hero', Hero)
